<!-- 银行账户信息 -->
<template>
  <section>
    <div class="personal-center-form__section">
      <h1 class="personal-center-form__title">银行账户信息</h1>
      <div class="personal-center-form__main">
        <div class="bankcard-list-container" v-show="showList">
          <ul class="bankcard-list">
            <li :class="['bankcard-list__list-item', item.bankAccountIsInUse === '1' ? 'is-selected' : '']"
                v-for="item in bankcardList" :key='item.selectedBankId'>

            <span class="bankcard-list__list——custom" v-show="item.isReturnAcount && item.isPayAcount">回款专户</span>
            <span class="bankcard-list__list——jscustom" v-show="item.isReturnAcount && item.isPayAcount">结算账户</span>
            <span class="bankcard-list__list——jscustom-single" v-show="item.isReturnAcount && !item.isPayAcount">回款专户</span>
            <span class="bankcard-list__list——jscustom-single" v-show="!item.isReturnAcount && item.isPayAcount">结算账户</span>
              <div class="bankcard-list__list-item__btn-container">
                <template v-if="Number(item.bankAccountIsInUse) === 0">
                  <span @click="editForm(item)">修改</span>
                  <span @click="isDeleteBankcard = true, selectedBankcard = item">删除</span>
                </template>
                <template v-else>
                  <span @click="checkForm(item)">查看</span>
                </template>

                <template v-if="Number(item.isSigned) === 0 && Number(item.isAuth) === 1 && Number(userInfo.crmCustomerType) === 1 ">
                  <span @click="toBankCardSign(item)">签约</span>
                </template>
              </div>
              <h5 class="bankcard-list__list-item__bank-name">{{item.bankName}}</h5>
              <h6 class="bankcard-list__list-item__branch-bank-name">{{item.bankBranchName}}</h6>
              <div class="bankcard-list__list-item__bankcard-num">{{item.bankAccountName | replaceBankcardNumWithStar}}
              </div>
            </li>
            <li class="bankcard-list__add" @click="newForm">
              <i class="el-icon-plus"></i>
            </li>
          </ul>
        </div>
        <div class="bankcard-form-container" v-show="!showList">
          <el-row :gutter="0" class="personal-center-form__form">
            <el-col :span="16">
              <el-form :label-width="'50%'" :model="bankcardForm" :rules="rules" ref="bankcardForm">
                <el-form-item label="开户名称">
                  <el-input type="text" v-model="bankcardForm.bankUserName" :disabled="!isEditBankcard"
                            placeholder="请输入开户名称" :maxlength="35"></el-input>
                </el-form-item>
                <el-form-item label="银行所属区域" prop="bankRegion">
                  <el-cascader :options="regionData" :props="bankRegionProps" :disabled="!isEditBankcard"
                               @active-item-change="changeRegionData"
                               v-model="bankcardForm.bankRegion" v-if="regionData"
                               placeholder="请选择银行所属区域"></el-cascader>
                </el-form-item>

                <el-form-item label="开户银行" prop="bankName">
                <el-select v-model="bankcardForm.bankName" filterable remote :remote-method="searchBankName"
                :disabled="!isEditBankcard" @change="changeBankName" placeholder="请输入关键字选择开户银行,如“中国银行”"
                @focus="showBankCardTips()">
                <el-option v-for="item in bankNameData" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="开户银行全称" prop="bankBranchName">
                  <el-input type="text" v-model="bankcardForm.bankBranchName" :disabled="!isEditBankcard"
                            placeholder="请输入开户银行全称" :maxlength="35"></el-input>
                </el-form-item>
<!--                <el-form-item label="开户行行号" prop="bankSwift">
                  <el-input type="text" v-model="bankcardForm.bankSwift" :disabled="!isEditBankcard"
                            placeholder="请输入开户行行号" :maxlength="35"></el-input>
                </el-form-item>-->
                <el-form-item label="开户账户" prop="bankAccountName">
                  <div class="showFormatBankAccountName" v-if="isShowFormatBANBox">
                    <span>{{bankAccountNameSpace}}</span>
                  </div>
                  <el-input type="text" v-model="bankcardForm.bankAccountName" :disabled="!isEditBankcard"
                            @input="addBankcardNumSpaces" @focus="showFormatBANBox" :maxlength="23"
                            placeholder="请输入开户账户"></el-input>
                </el-form-item>
                <el-form-item label="账户类型" prop="bankUseTypeArr">
                    <el-checkbox-group v-model="bankcardForm.bankUseTypeArr">
                      <el-checkbox label="0" :disabled="true">回款专户</el-checkbox>
                      <el-checkbox label="1" :disabled="true">结算账户</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div class="text-center" v-if="!showList">
          <el-button type="primary" v-if="isEditBankcard" style="background:#EB662B;" :loading="isSubmitting" class="personal-center-form__submit"
                     @click="saveBankcard">
            确定
          </el-button>
          <el-button type="primary" style="background:#EB662B;" class="personal-center-form__submit" @click="hideForm">
            返回
          </el-button>
        </div>
      </div>
    </div>
    <confirm-modal :show="isDeleteBankcard" content="是否确定删除银行账户？" @confirm-click="deleteBankcard"
                   @cancel-click="isDeleteBankcard = false"></confirm-modal>
  </section>
</template>
<script>
  import placeholders from '../../scripts/placeholders';
  import _ from 'lodash';
  import {mapGetters, mapActions} from 'vuex';
  import * as types from '../../vuex/types/type';
  import api from '../../api/common';
  import bankCardListApi from '../../api/personalCenter/bankCardList';
  import confirmModal from '../common/Confirm.vue';

  export default {
    components: {
      confirmModal
    },
    directives: {
      focus: {
        inserted: function(el) {
          el.querySelector("input").focus();
        }
      }
    },
    data () {
      return {
        arr: [],
        showList: true,
        isSubmitting: false,
        isEditBankcard: false,
        isDeleteBankcard: false,
        bankAccountNameSpace: '',
        isShowFormatBANBox: false,
        BankContract: false, // 银行贷款协议
        bankRegionProps: {
          value: 'code',
          label: 'name',
          children: 'children'
        },
        bankNameData: [],
        selectedBank: {},
        selectedBankcard: {},
        rules: {
          bankType: [{
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.trim() === '') {
                callback(new Error('请选择账户种类'));
              } else {
                callback();
              }
            }
          }],

          bankRegion: [{
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.length === 0) {
                callback(new Error('请选择银行所属区域'));
              } else {
                callback();
              }
            }
          }],
          bankName: [{
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.trim() === '') {
                callback(new Error('请输入开户银行'));
              } else {
                callback();
              }
            }
          }],
          bankBranchName: [{
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.trim() === '') {
                callback(new Error('请输入开户银行全称'));
              } else {
                callback();
              }
            }
          }],
         /* bankSwift: [{
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.trim() === '') {
                callback(new Error('请输入开户行行号'));
              } else {
                callback();
              }
            }
          }],*/
          bankAccountName: [{
            trigger: 'blur',
            validator: (rules, value, callback) => {
              value = value.replace(/\s/g, '');
              this.isShowFormatBANBox = false;
              if (value.trim() === '') {
                callback(new Error('请输入开户账户'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('请输入正确的银行卡账户号码'));
              } else if (value.length < 12) {
                callback(new Error('银行卡账户号码不能小于12位'));
              } else if (value.length > 30) {
                callback(new Error('银行卡账户号码不能大于30位'));
              } else {
                callback();
              }
            }
          }],
          hasReadContract: [{
            trigger: 'change',
            validator: (rules, value, callback) => {
              if (!value) {
                callback(new Error('必须阅读并同意《贷款协议》'));
              } else {
                callback();
              }
            }
          }],
          bankUseTypeArr:[{
            trigger: 'change',
            validator: (rules, value, callback) => {
              if (value.length === 0) {
                callback(new Error('请勾选账户类型'));
              } else {
                callback();
              }
            }
          }]
        },
        bankcardForm: {
          // bankSwift:'',//开户行行号
          bankUseTypeArr:['0','1'],
          bankUseType:"",//账户类型
          bankType: '',
          bankRegion: [],
          bankName: '',
          bankNameValue: '',
          bankBranchName: '',
          bankAccountId: '',
          bankAccountName: '',
          hasReadContract: false
        }
      };
    },

    computed: {
      ...mapGetters({
        userInfo: types.GET_USER,
        bankcardList: types.GET_BANKCARD_LIST,
        regionData: types.GET_REGION_DATA,
        bankUserName: types.GET_BANKCARD_LIST_NAME,
        customerType: types.GET_BANKCARD_LIST_NAME_TYPE
      })
    },
    methods: {
      ...mapActions({
        getBankcardList: types.SET_BANKCARD_LIST,
        getProvinceData: types.SET_PROVINCE_DATA,
        getCityAndDistrictData: types.SET_CITY_AND_DISTRICT_DATA,
        saveBankcardInfo: types.SAVE_BANKCARD_INFO,
        deleteBankcardInfo: types.DELETE_BANKCARD_INFO,
      }),

      checkForm (bankcard) {
        let dom = this.$refs["bankcardForm"];
        dom.$el.scrollIntoView({
          block: "center",
          behavior: "smooth"
        });
        const _this = this;
        this.showList = false;
        this.isEditBankcard = false;
        this.getCityAndDistrictData({
          val: [bankcard.bankProvince]
        }).then(() => {
          this.getCityAndDistrictData({
            val: [bankcard.bankProvince, bankcard.bankCity]
          }).then(() => {
            _this.arr = [bankcard.bankProvince, bankcard.bankCity, bankcard.bankCounty];
            _this.bankcardForm.bankUserName = bankcard.bankUserName;
            _this.bankcardForm.bankName = bankcard.bankName;
            _this.bankcardForm.bankNameValue = bankcard.bankNameValue;
            _this.bankcardForm.bankBranchName = bankcard.bankBranchName;
            _this.bankcardForm.bankAccountId = bankcard.bankAccountId;
            _this.bankcardForm.bankAccountName = bankcard.bankAccountName;
            _this.bankcardForm.bankRegion = _this.arr;
            if(bankcard.bankUseType){
              _this.bankcardForm.bankUseTypeArr = bankcard.bankUseType.split(",");
            }
            _this.selectedBank = {
              bankName: bankcard.bankName,
              bankNameValue: bankcard.bankNameValue
            };
            _this.addBankcardNumSpaces();
          });
        });
      },
      newForm () {
        this.showList = false;
        this.isEditBankcard = true;
        this.$refs.bankcardForm.resetFields();
        this.bankcardForm.bankAccountId = '';
        this.bankcardForm.bankNameValue = '';
        this.bankcardForm.bankUserName = this.bankUserName;
        this.bankcardForm.bankType = this.customerType == 1 ? '借记卡' : '企业账户';
        this.bankNameData = [];
        setTimeout(() => {
          placeholders.placeHolder(this);
        }, 30);
      },
      editForm (bankcard) {
        const _this = this;
        this.showList = false;
        this.isEditBankcard = true;
        this.getCityAndDistrictData({
          router: this.$router,
          val: [bankcard.bankProvince]
        }).then(() => {
          this.getCityAndDistrictData({
            val: [bankcard.bankProvince, bankcard.bankCity]
          }).then(() => {
            _this.arr = [bankcard.bankProvince, bankcard.bankCity, bankcard.bankCounty];
            _this.bankcardForm.bankType = _this.customerType == 1 ? '借记卡' : '企业账户';
            _this.bankcardForm.bankUserName = bankcard.bankUserName
            _this.bankcardForm.bankName = bankcard.bankName;
            _this.bankcardForm.bankNameValue = bankcard.bankNameValue;
            _this.bankcardForm.bankBranchName = bankcard.bankBranchName;
            _this.bankcardForm.bankAccountId = bankcard.bankAccountId;
            _this.bankcardForm.bankAccountName = bankcard.bankAccountName;
            // _this.bankcardForm.bankSwift = bankcard.bankSwift || '';
            _this.bankcardForm.bankRegion = _this.arr;
            _this.bankcardForm.bankUseType = bankcard.bankUseType;
            _this.bankcardForm.hasReadContract = true;
            if(bankcard.bankUseType){
              _this.bankcardForm.bankUseTypeArr = bankcard.bankUseType.split(",");
            }
            _this.selectedBank = {
              bankName: bankcard.bankName,
              bankNameValue: bankcard.bankNameValue
            };
            _this.addBankcardNumSpaces();
          });
        });

      },
      deleteBankcard () {
        this.deleteBankcardInfo({
          router: this.$router,
          token: this.userInfo.token,
          bankAccountId: this.selectedBankcard.bankAccountId
        }).then(() => {
          this.isDeleteBankcard = false;
          this.getBankcardList({
            router: this.$router,
            token: this.userInfo.token
          });
        });
      },
      hideForm () {
        this.showList = true;
        this.$refs.bankcardForm.resetFields();
        this.bankcardForm.bankAccountId = '';
        this.bankcardForm.bankNameValue = '';
      },

      addBankcardNumSpaces () {
        const that = this;
        const spaceRE = /(\s*)/g;  // 正则-所有空格
        const spaceEndRE = /(\s*$)/g;  // 正则-末位空格
        that.bankAccountNameSpace = that.bankcardForm.bankAccountName;
        that.bankAccountNameSpace = that.bankAccountNameSpace.replace(spaceRE, '').replace(/(\d{4})(?=\d)/g, '$1 ').replace(spaceEndRE, ''); // 替换末位空格
      },
      showFormatBANBox () {
        this.bankAccountNameSpace = this.bankcardForm.bankAccountName;
        this.addBankcardNumSpaces();
        this.isShowFormatBANBox = true;
      },
      changeRegionData (val) {
        this.getCityAndDistrictData({val});
      },
      searchBankName (bankName) {
        bankCardListApi.getBankcardSelectData({
          token: this.userInfo.token,
          bankName
        }).then((res) => {
          const resData = res.data;
          if (Number(resData.code) === 0) {
            this.bankNameData = resData.bankNameList;
          } else {
            this.bankNameData = [];
          }
        });
      },
      changeBankName (val) {
        const selecteBank = _.find(this.bankNameData, item => item.value === val);
        if (this.bankNameData.length && !_.isEmpty(val)) {
          this.selectedBank = {
            bankName: selecteBank.text,
            bankNameValue: selecteBank.value
          };
        }
      },
      saveBankcard () {
        for(let i = 0;i < this.bankcardForm.bankUseTypeArr.length; i++) {
            if(i == 0){
              this.bankcardForm.bankUseType = this.bankcardForm.bankUseTypeArr[i];
            }else{
              this.bankcardForm.bankUseType = this.bankcardForm.bankUseType+","+this.bankcardForm.bankUseTypeArr[i];
            }
        }
        this.$refs.bankcardForm.validate((valid) => {
          if (valid) {
            this.isSubmitting = true;
            this.saveBankcardInfo({
              router: this.$router,
              token: this.userInfo.token,
              customerId: this.userInfo.crmCustomerId,
              bankType: 1,
              bankUserName: this.bankUserName,
              bankAccountName: `${this.bankcardForm.bankAccountName}`.replace(/\s/g, ''),
              bankName: this.selectedBank.bankNameValue,
              bankBranchName: this.bankcardForm.bankBranchName,
              bankAccountId: this.bankcardForm.bankAccountId,
              bankCounty: this.bankcardForm.bankRegion[2],
              bankProvince: this.bankcardForm.bankRegion[0],
              bankCity: this.bankcardForm.bankRegion[1],
              bankUseType: this.bankcardForm.bankUseType
              // bankSwift:this.bankcardForm.bankSwift
            }).then((res) => {
              const resData = res.data;
              this.isSubmitting = false;
              if (Number(resData.code) === 0) {
                this.getBankcardList({
                  router: this.$router,
                  token: this.userInfo.token
                });
                this.showList = true;
                this.$refs.bankcardForm.resetFields();
                this.bankcardForm.bankAccountId = '';
                this.bankcardForm.bankNameValue = '';
                this.bankNameData = [];
              }
            });
          } else {
            setTimeout(() => {
              placeholders.placeHolder(this);
            }, 30);
            return false;
          }
        });
      },
      toBankCardSign (item) {
        this.$router.push({
          name: 'bankCardSign', params: {bankAccountName: item.bankAccountName}
        });
      },

    },
    mounted () {
      this.getProvinceData();
      this.getBankcardList({
        router: this.$router,
        token: this.userInfo.token,
        type: Number(this.userInfo.crmCustomerType)
      });
    }
  };
</script>
<style lang="scss">
  @import "../../styles/bankcardList";

  .personal-center-form__main {
    .bankcard-list-container {
      padding: 75px 130px;
    }

    label[for='bankAccountName'] + .el-form-item__content {
      position: relative;
    }

    .showFormatBankAccountName {
      position: absolute;
      top: 36px;
      left: 0;
      height: 38px;
      width: 353px;
      background: #fff;
      z-index: 100;
      span {
        display: inline-block;
        padding-left: 10px;
        width: 343px;
        height: 100%;
        border-left: 1px solid #dcdcdc;
        border-right: 1px solid #dcdcdc;
        border-bottom: 1px solid #dcdcdc;
      }
    }

  }

  .bank-card-tips p {
    position: absolute;
    top: 18px;
    /*left: 20px;*/
    color: #ff4949;
    font-size: 12px;
    font-family: antialiased;
  }

  .el-select-dropdown__wrap {
    min-width: 370px \9
  ;
  }

  .bankContract{
    margin-right:150px;
    position: relative;
    .step1__show-loan-contract3 {
      position: absolute;
      left: 67% !important;
      top: 0px !important;
      color: $orange;
      cursor: pointer;
      display: inline-block;
      width: 100px !important;
      border:0;
      padding: 0;
    }
  }
  .bankContract .el-form-item__error {
    margin-left: 100px;
}
.bankcard-list__list——custom{
    color: #eb662b;
    padding-left: 130px;
    font-size: 13px;
    display: block;
    float: left;
    padding-top:15px;
    font-weight: bold;
}
.bankcard-list__list——jscustom{
    color: #eb662b;
    font-size: 13px;
    padding-left: 10px;
    padding-top:15px;
    display: block;
    float: left;
    font-weight: bold;
}
.bankcard-list__list——jscustom-single{
    color: #eb662b;
    font-size: 13px;
    padding-left: 200px;
    padding-top:15px;
    display: block;
    float: left;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// BankcardInfo.vue?87028634